export default __webpack_public_path__ + "static/media/october_2022.ee7685a9.pdf";